import React from "react";
import { Switch, Redirect, useRouteMatch, Route } from "react-router-dom";
import ReviewMQ from "./Reviews/ReviewMQ";
import ReviewMultiSarf from "./Reviews/MultiSarf/Review";

import ReportSafesJard from "./comps/Safes/BackEnd/Tab1Rout/ReportSafesJard";

import HesabCustAmeel from "./comps/Customers/BackEnd/Tab1Rout/HesabCustAmeel";
import HesabCustMored from "./comps/Customers/BackEnd/Tab1Rout/HesabCustMored";
import "./i18n";

// Settings
import SettingsPrinter from "./comps/Settings/SettingsPrinter";
import PrintCasher from "./comps/Settings/PrintCasher";
import Settings from "./comps/Settings/Settings";
import ReData from "./comps/Settings/ReData";
import SimpleData from "./comps/bascDatas/SimpleData";
import NormalData from "./comps/bascDatas/NormalData";
import Reports from "./comps/Taqrer/Reports";
import MultiQbd from "./comps/Accounts/BackEnd/Tabs/MultiQbd";
import MultiSarf from "./comps/Accounts/BackEnd/Tabs/MultiSarf";
import Sandskharji from "./comps/Accounts/BackEnd/Tabs/Sandskharji";
// import FirstTermInvoice from "./comps/Invs/BackEnd/first-term-invoice";

import DeptCards from "./Fronts/DeptsMenues/DeptCards";
// Safes

import { createTheme } from "@material-ui/core/styles";

import { MuiThemeProvider } from "@material-ui/core/styles";
import ReviewAmeelMoard from "./Reviews/Customers/Balance/ReviewAmeelMoard";
import RevAccounting from "./Reviews/Accounts/Balance/RevAccounting";
import RevSandC from "./Reviews/Accounts/Kharji/Casher/RevSandC";
import ReviewEqfalEveryDay from "./Reviews/Sales/Eqfal/ReviewEqfalEveryDay";
import ReviewSalTafsele from "./Reviews/Sales/Tafsele/ReviewSalTafsele";
import ReviewEveryDay from "./Reviews/Sales/EvryDay/ReviewEveryDay";
import ReportTaxPrinter from "./Reviews/Accounts/rptTaxPrint/ReportTaxPrinter";
import GlobalContext from "./Context/GlobalContext";
import { sto } from "./Context/InshData";
import { useEffect } from "react";
import InternalSand from "./comps/Accounts/BackEnd/Tabs/InternalSand";
import GroupsCon from "./comps/bascDatas/Tab1/groups/groupsCon";
import TaswayaPrint from "./Reviews/Safes/taswya/TaswyaPrint";
import RevCasherBuilder from "./Reviews/Invs/run-time-design/RevCasher";
import TrunItemsAvg from "./comps/Safes/BackEnd/TrunItemsAvg/TrunItemsAvg";
import { AccountsIndexCont } from "./comps/Accounts/BackEnd/AccountsIndexes/AccountIndexCont";
import SaleAnalysisCon from "./comps/Sales/BackEnd/Tab1Rout/SaleAnalysis/saleAnalysisCon";
import CurrencySalesProfitCon from "./comps/Sales/BackEnd/Tab1Rout/CurrencySalesProfit/CurrencySalesProfitCon";
import EmpSalesCon, {
  EmpPurchCon,
} from "./comps/Sales/BackEnd/Tab1Rout/EmpSales/EmpSalesCon";
import CashairNoTax from "./Reviews/Invs/CashierNoTax/CashairNoTax";

import SaleAnalysisPrint from "./Reviews/Sales/sale-analysis/SaleAnalysisPrint";
import DashboardCon from "./comps/Dashboard/DashboardCon";
import OmlatCon from "./comps/bascDatas/omlat/omlatCon";
import ChangePassword from "./comps/users/change-password";
import EReceiptVoucherCon from "./comps/Accounts/BackEnd/receipt-voucher/external-receipt-voucher/ERVCon";
import EExchangeVoucherCon from "./comps/Accounts/BackEnd/receipt-voucher/external-exchange-voucher/EEVCon";
import UserCon from "./comps/Customers/BackEnd/users/userCon";
import AccountingRPTCon from "./comps/Accounts/BackEnd/AccountingRPT/accountingRPTCon";
import SafesCon from "./comps/bascDatas/safes/safesCon";
import StocksCon from "./comps/bascDatas/stocks/stocksCon";
import DefaultSettingsCon from "./comps/Settings/defaultSettings/default-settingsCon";
import IExchangeVoucherCon from "./comps/Accounts/BackEnd/receipt-voucher/internal-exchange-voucher/IEVCon";
import IReceiptVoucherCon from "./comps/Accounts/BackEnd/receipt-voucher/internal-receipt-voucher/IRVCon";
// import SalesManInvoice from "./comps/Invs/BackEnd/salesman-invoice";
import CustomersCon from "./comps/Customers/customers/customersCon";
import AccountCustRPTCon from "./comps/Customers/accountCustRPT/accountingRPTCon";
import BalanceCustRPTCon from "./comps/Customers/balanceCustRPT/balanceCustRPTCon";
import PaymentTransactionRPTCon from "./comps/Customers/paymentTransactionRPT/paymentTransactionRPTCon";
import BillTemplate from "./Reviews/Invs/bill-template/bill-template";
import MReceiptVoucherCon, {
  MExchangVoucherCon,
} from "./comps/Accounts/BackEnd/receipt-voucher/multi-receipt-voucher/MVCon";
import MultiVoucherView from "./Reviews/MultiVoucherView";
import ProfitMarginCon from "./comps/Sales/BackEnd/Tab1Rout/profit-margin/ProfitMarginCon";
import ResturantCasher from "./Reviews/Invs/casher-resturant/RevCasher";
import GoldTemplate from "./Reviews/Invs/gold-template/gold-template";
import SafeGrdCon from "./comps/Safes/BackEnd/safe-grd/SafeGrdCon";
import BackupAllDataBase from "./comps/Settings/backup-all-db";
import BackupDataBase from "./comps/Settings/backup-db";
import UserPermissionsCon from "./comps/Settings/user-permissions/user-permissions-con";
import VoucherTemplate from "./Reviews/Accounts/voucher-template/voucher-template";
import UsersPermissionsCont from "./comps/users/UserPermissions/UserPermissionsCont";
// import ORestrictionsCon from "./comps/Accounts/BackEnd/opening-restrictions/opening-restrictionsCon";
import RevCasher from "./Reviews/Invs/CasherReadyDisigen/RevCasher";
import Bigen from "./Start/Bigen";
import PrivateRoute from "./utils/PrivateRoute";
import { NotFound } from "./POS/views";
import CostCentersCon from "./comps/bascDatas/Tab1/CostCenters/CostCentersCon";
import CostCenterRptCon from "./comps/Accounts/BackEnd/CostCenterRpt/CostCenterRptCon";
import PrintExample from "./Reviews/Invs/bill-template/printExample";
import BigenDemo from "./Start/Bigen-demo";
import EmpoyeesCon from "./comps/users/employees/EmpoyeesCon";
import SalesPersonCon from "./comps/bascDatas/SalesPerson/SalesPersonCon";
import SafeTransferPrint from "./Reviews/Safes/transefer/TransferPrint";
import PurchAnalysisCon from "./comps/Sales/BackEnd/Tab1Rout/SaleAnalysis/purchAnalysisCon";
import ElectronicScaleCon from "./comps/Settings/electronic-scale/electronic-scaleCon";
import ZatcaSettingsCon from "./comps/Settings/zatca-settings/zatcaCon";
import InvoiceSettings from "./comps/Settings/invoiceSettings";
import BillTemplateTwoBuilder from "./Reviews/Invs/bill-template02-builder/bill-template-two";
import InvoiceSettingsApp from "./comps/Settings/invoice-settings/invoice-settings";
// import DRestrictionsCon from "./comps/Accounts/BackEnd/Restrictions/daily-restrictionsCon";
import StockMoveRPTCon from "./comps/Sales/BackEnd/Tab1Rout/stock-move/stockMoveCon";
import BanksCon from "./comps/bascDatas/banks/banksCon";
import LoginTest from "./login";
import SubscriptionRenewCon from "./comps/Settings/subscription-renew/subscription-renewCon";
import RevCostCenter from "./Reviews/Accounts/CostReportPrint/RevCostCenter";
import DefaultInv from "./Reviews/Invs/AFReadyDisigen/DefaultInv";
import InvCompany from "./Reviews/Invs/invCompany/invCompanytow";
import ReviewJardReport from "./Reviews/Safes/Jard/RevJard";
import RevMaintainceInv from "./Reviews/Invs/maintaince/maintainceinv";
import RevMezanPrint from "./Reviews/Accounts/mezanPrint/MezanPrint";
import SalesDetialsCon from "./comps/Sales/BackEnd/Tab1Rout/SalesDetailsReprot/SalesDetialsCon";
import CloseReportsCon from "./comps/Sales/BackEnd/Tab1Rout/EqfalEveryDay/CloseReportsCon";
import DailyReportsCon from "./comps/Sales/BackEnd/Tab1Rout/EveryDay/DailyReortsCon";
import ActivitySalesReportsCon from "./comps/Sales/BackEnd/Tab1Rout/Activity/ActivitySalesReportsCon";
import ActivityPurchReportCon from "./comps/Purchases/ActivityReport/ActivityPurchReportCon";
import RevActivityReport from "./Reviews/Sales/Activity/RevActivityReport";
import VatReportSalesCon from "./comps/Sales/BackEnd/Tab1Rout/VatReport/VatReportSalesCon";
import RevVatReport from "./Reviews/Sales/TaxSalePrint/RevVatReport";
import RevSalesEmp from "./Reviews/Sales/sales-man/SalesEmpPrint";
import ItemsMoveCon from "./comps/Safes/BackEnd/ItemsMovment/ItemsMoveCon";
import RevRestriction from "./Reviews/Accounts/restPrint/RevRestriction";
import RevDailyReport from "./Reviews/Sales/EvryDay/RevDailyReport";
import DeptPeriodConn from "./comps/Customers/DeptPeri/DeptPeriodConn";
import ReviewAgelPeriod from "./Reviews/Customers/AgelPeriod/AgelPeriod";
import AddItemsContainer from "./comps/bascDatas/Tab1/items/AddItems/ItemsCon";
import GardUnitCon from "./comps/Safes/BackEnd/GardUnit/GardUnitCon";
import RevGardUnitts from "./Reviews/Safes/jardunits/RevGardUnitts";
import SalesmansCon from "./comps/Sales/BackEnd/Tab1Rout/Salesmans/SalesmanCon";
import RevSalesmans from "./Reviews/Sales/Salesmanp/RevSalesman";
import SafesTransferCon from "./comps/Safes/BackEnd/SafesTransfers.js/SafesTransfercon";
import ReviewTransfers from "./Reviews/Safes/transefer/RevTransfer";
import SafesRecieveCon from "./comps/Safes/BackEnd/SafesTransfers.js/SafesRecieveCon";
import InvoicesContianers from "./comps/Invs/BackEnd/Invoices/InvoicesContianers";
import ShiftsReportCon from "./comps/Sales/BackEnd/Tab1Rout/ShiftsEmpReport/ShiftsReportCon";
import PurchaseDetailsCon from "./comps/Purchases/PuchaseDetails/PurchaseDetailsCon";
import DailyJenralCon from "./comps/Accounts/BackEnd/DailyJenral.js/DailyJenralCon";
import RevShiftsCachierCon from "./Reviews/Sales/Shiftt/RevShiftsCachierCon";
import RevShiftsA4 from "./Reviews/Sales/Shiftt/RevShiftsA4";
import RevCustomersBalance from "./Reviews/Customers/CustsBalance/RevCustomersBalance";
import RevLastPaid from "./Reviews/Customers/LastPaid/RevLastPaid";
import DeliveryNotes from "./Reviews/Invs/DeliveryNotes/DeliveryNotes";
import EnglishInv from "./Reviews/Invs/EnglishInv/EnglishInv";
import SafesTaswyaCon from "./comps/Safes/BackEnd/SafesTaswya/SafesTaswyaCon";
import TwreedSafesCon from "./comps/Safes/BackEnd/SarfTwreed/TwreedSafesCon";
import IntermediateAccCon from "./comps/Accounts/BackEnd/IntermediateAcc/IntermediateAccCon";
import SarfSafesCon from "./comps/Safes/BackEnd/SarfTwreed/SarfSafesCon";
import InvsSearch from "./Reviews/Sales/InvsSearch/InvsSearch";
import RestInvoicesCon from "./comps/Invs/BackEnd/Invoices/RestInvoicesCon";
import VatReportTowCon from "./comps/Accounts/BackEnd/VatReportTow/VatReportTowCon";
import VatReportsOneCon from "./comps/Accounts/BackEnd/VatReportsOne/VatReportsOneCon";
import VatPrintOne from "./Reviews/Accounts/VatReportPrint.js/VatPrintOne";
import AccountsSystemCon from "./comps/Accounts/BackEnd/AccountsSystem/AccountsSystemCon";
import ItemsMovementTotalCon from "./comps/Safes/BackEnd/ItemsMovementTotal/ItemsMovementTotalCon";
import PrintInvCashair from "./Reviews/Invs/CasherNewDisigen/PrintInvCashair";
import SadadInvoicesCon from "./comps/Sales/BackEnd/Tab1Rout/SadadInvoices/SadadInvoicesCon";
import FoundationCon from "./comps/bascDatas/Tab1/Foundations/FoundationCon";
import PumpsCons from "./comps/bascDatas/Pumps/PumpsCons";
import AnnualSuscriptionCon from "./comps/Settings/AnnualSuscription/AnnualSuscriptionCon";
import AccountConfirmation from "./Reviews/Accounts/AccountConfirmation/AccountConfirmation";
import InvTempalte from "./Reviews/Invs/Inv_Tempalte/Inv_Tempalte";
import EmployeesSalaryCon from "./comps/users/employeesSalary/EmployeesSalaryCon";
import RestrictionCon from "./comps/Accounts/BackEnd/Restriction/RestrictionCon";
import RestrictionOpenCon from "./comps/Accounts/BackEnd/Restriction/RestrictionOpenCon";
import EmployeeAdvancesCon from "./comps/users/EmployeeAdvances/EmployeeAdvancesCon";
import SalaryPrint from "./Reviews/Employees/SalaryPrint";
import LevelsCon from "./comps/bascDatas/Levels/LevelsCon";
import PricesLevelsCon from "./comps/bascDatas/PricesLevels/PricesLevelsCon";
const MainRoutes = () => {
  if (!sto)
    return (
      <Switch>
        <Route exact path="/" component={Bigen} />
        {/* for dimo */}
        {/* <Route exact path="/" component={BigenDemo} /> */}
      </Switch>
    );
  return (
    <Switch>
      <Route exact path="/" component={Bigen} />
      {/* for dimo */}
      {/* <Route exact path="/" component={BigenDemo} /> */}
      <Route path="/groups" component={GroupsCon} />
      {/* <Route exact path='/' component={Custos} /> */}
      {/* <Route exact path="/restInsert" component={DRestrictionsCon} /> */}
      <Route exact path="/restInsert" component={RestrictionCon} />

      <Route path="/print" component={PrintExample} />
      <Route path="/ReportAcc" component={AccountingRPTCon} />
      {/* <Route path="/Foundation" component={Foundation} /> */}
      <Route path="/Foundation" component={FoundationCon} />
      <Route path="/Pumps" component={PumpsCons} />


      {/* <Route path='/SalesInvO' component={SalesInvO} /> */}
      <Route path="/item" component={AddItemsContainer} />
      <Route path="/VatReports" component={VatReportTowCon} />

      {/* <Route path="/item" component={ItemsCon} /> */}


      {/* <Route path='/unit' component={Units} /> */}
      {/* <Route path="/reportTax" component={ReportTax} /> */}
      <Route path="/reportTax" component={VatReportsOneCon} />
      <Route path="/VatReportOne" component={VatPrintOne} />


      <Route path="/SimData" component={SimpleData} />
      <Route path="/NormData" component={NormalData} />
      <Route path="/Omlat" component={OmlatCon} />
      <Route path="/change-password" component={ChangePassword} />
      {/* <Route path='/Invoces' component={Invoces} /> */}
      {/* <Route path="/Invoces" component={InvoiceCon} /> */}
      {/* <Route path="/Invoces" component={InvoiceCon} /> */}
      <Route path="/Invoces" component={InvoicesContianers} />

      <Route path="/Invoices" component={InvoicesContianers} />


      {/* <Route path="/first-term-invoice" component={FirstTermInvoice} /> */}

      {/* <Route path="/-invoice" component={SalesManInvoice} /> */}
      <Route path="/mQbd" component={MultiQbd} />
      <Route path="/mSarf" component={MultiSarf} />
      <Route path="/Sands" component={Sandskharji} />
      <Route path="/internal-sand" component={InternalSand} />
      <Route path="/Customers" component={CustomersCon} />
      <Route path="/ReporteveryDay" component={DailyReportsCon} />
      <Route path="/Shifts" component={ShiftsReportCon} />
      <Route path="/PurchaseDetails" component={PurchaseDetailsCon} />
      <Route path="/DeleveryNotes" component={DeliveryNotes} />
      <Route path="/EngInv" component={EnglishInv} />




      {/* <Route path="/ReportEqfalEveryDay" component={ReportEqfalEveryDay} /> */}
      <Route path="/ReportEqfalEveryDay" component={CloseReportsCon} />

      <Route path="/Activity" component={ActivitySalesReportsCon} />
      {/* <Route path="/Activity" component={ReportActivity} /> */}

      <Route path="/Activityp" component={ActivityPurchReportCon} />
      {/* <Route path="/Activityp" component={ReportActivityP} /> */}

      {/* <Route path="/ReportSalTafsele" component={ReportSalTafsele} /> */}
      <Route path="/ReportSalTafsele" component={SalesDetialsCon} />

      <Route path="/ReportSaleAnalysis" component={SaleAnalysisCon} />
      <Route path="/ReportPurchAnalysis" component={PurchAnalysisCon} />
      <Route path="/ReportProfitMargin" component={ProfitMarginCon} />
      <Route path="/ReportEmpSales" component={EmpSalesCon} />
      <Route path="/ReportEmpPurches" component={EmpPurchCon} />
      <Route path="/CurrencySalesProfit" component={CurrencySalesProfitCon} />
      <Route path="/ReportSafesJard1" component={ReportSafesJard} />
      <Route path="/ReportSafesJard" component={SafeGrdCon} />
      <Route path="/Reports" component={Reports} />

      <Route path="/HesabCustM" component={AccountCustRPTCon} />
      <Route path="/HesabCustA" component={AccountCustRPTCon} />
      <Route path="/BalanceCustRPT" component={BalanceCustRPTCon} />
      <Route path="/HesabCustAmeel" component={HesabCustAmeel} />
      <Route path="/HesabCustMored" component={HesabCustMored} />
      <Route path="/SettingsP" component={SettingsPrinter} />
      <Route path="/casher" component={PrintCasher} />
      <Route path="/Sett" component={Settings} />
      <Route path="/Refresh" component={ReData} />
      <Route path="/backup-all" component={BackupAllDataBase} />
      <Route path="/backup" component={BackupDataBase} />
      <Route path="/AnnualScreen" component={AnnualSuscriptionCon} />
      <Route path="/A" component={DefaultInv} />
      <Route path="/RevCompany" component={InvCompany} />
      <Route path="/RevInv" component={RevMaintainceInv} />
      <Route path="/invSearch" component={InvsSearch} />
      <Route path="/bill2" component={BillTemplate} />
      {/* <Route path="/bill4" component={BillTemplateTwo} /> */}
      <Route path="/bill4" component={InvTempalte} />
      <Route path="/voucher2" component={VoucherTemplate} />
      <Route path="/Invoces/bill2" component={BillTemplate} />
      <Route path="/gold-bill" component={GoldTemplate} />
      <Route path="/C" component={RevCasher} />
      <Route path="/CashairNoTax" component={CashairNoTax} />
      <Route path="/CashairInv" component={PrintInvCashair} />

      <Route path="/RestCasher" component={ResturantCasher} />
      {/* <Route path='/ReviewMSQ' component={ReviewMSQ} /> */}
      <Route path="/ReviewMQ" component={ReviewMQ} />
      <Route path="/MulVoucher" component={MultiVoucherView} />
      <Route path="/ReviewMS" component={ReviewMultiSarf} />
      {/* <Route path='/ReviewAaM' component={ReviewAmeelMoard}  /> */}
      <Route path="/RevConfirm" component={AccountConfirmation} />
      <Route path="/ReviewAaM" component={ReviewAmeelMoard} />

      <Route path="/ReviewEqfal" component={ReviewEqfalEveryDay} />
      <Route path="/ReviewActivity" component={RevActivityReport} />
      <Route path="/ReviewTafsel" component={ReviewSalTafsele} />
      <Route path="/ReviewEDay" component={ReviewEveryDay} />
      <Route path="/RevDailyReport" component={RevDailyReport} />
      <Route path="/CahierShifts" component={RevShiftsCachierCon} />
      <Route path="/ReviewShifts" component={RevShiftsA4} />

      {/* <Route path="/ReviewJard" component={ReviewJard} /> */}
      <Route path="/ReviewJard" component={ReviewJardReport} />
      <Route path="/ReviewAccount" component={RevAccounting} />
      <Route path="/ReviewCostCenter" component={RevCostCenter} />
      <Route path="/mult-receipt" component={MReceiptVoucherCon} />
      <Route path="/mult-exchange" component={MExchangVoucherCon} />
      {/* <Route path="/CustBalance" component={CustomerBalance} /> */}
      <Route path="/CustBalance" component={RevCustomersBalance} />
      <Route path="/SalaryPay" component={EmployeesSalaryCon} />
      <Route path="/EmpAdvances" component={EmployeeAdvancesCon} />
      <Route path="/SalaryPrint" component={SalaryPrint} />




      <Route path="/RP" component={RevRestriction} />

      <Route path="/SC" component={RevSandC} />
      {/* <Route path="/reStore" component={ReMakeStoreCon} /> */}
      <Route path="/reStore" component={SafesTaswyaCon} />

      {/* <Route path="/store-exch" component={StoreExchangeCon} /> */}
      <Route path="/store-exch" component={SarfSafesCon} />

      {/* <Route path="/store-supp" component={StoreSupplyCon} /> */}
      <Route path="/store-supp" component={TwreedSafesCon} />

      <Route path="/RTP" component={ReportTaxPrinter} />
      <Route path="/TASP" component={TaswayaPrint} />
      <Route path="/sale-report-tax" component={VatReportSalesCon} />
      <Route path="/SadadInvoices" component={SadadInvoicesCon} />

      {/* <Route path="/sale-report-tax" component={SaleReportTax} /> */}
      <Route path="/depts" component={DeptCards} />
      {/* <Route path="/TSP" component={TaxSalePrint} /> */}
      <Route path="/TSP" component={RevVatReport} />
      <Route path="/IntermadateAccounts" component={IntermediateAccCon} />


      {/* <Route path="/SafeGrdUnits" component={SafeGrdUnits} /> */}
      <Route path="/SafeGrdUnits" component={GardUnitCon} />
      <Route path="/ReviewJardUnits" component={RevGardUnitts} />


      <Route path="/curr-details-rpt" component={ItemsMoveCon} />
      <Route path="/ItemsTotalMovement" component={ItemsMovementTotalCon} />

      <Route path="/trun-items-avg" component={TrunItemsAvg} />
      <Route path="/example" component={RevCasherBuilder} />
      <Route path="/example01" component={BillTemplateTwoBuilder} />
      <Route path="/chart" component={DashboardCon} />
      <Route path="/accounts-index" component={AccountsIndexCont} />
      <Route path="/DailyJenral" component={DailyJenralCon} />


      {/* <Route path="/StoreTransfer" component={StoreTransferCon} /> */}
      <Route path="/StoreTransfer" component={SafesTransferCon} />

      {/* <Route path="/ReceiveST" component={ReceiveSTCon} /> */}
      <Route path="/ReceiveST" component={SafesRecieveCon} />

      <Route path="/AnalysisPrint" component={SaleAnalysisPrint} />
      {/* <Route path="/MainRBalance" component={MainRBalanceCon} /> */}
      <Route path="/MainRBalance" component={AccountsSystemCon} />

      {/* <Route path="/MainRBalanceRpint" component={TrialBalance} /> */}
      {/* <Route path="/MainRBalanceRpint" component={BalanceSheetRPT} /> */}
      <Route path="/MainRBalanceRpint" component={RevMezanPrint} />

      <Route path="/ext-receipt" component={EReceiptVoucherCon} />
      <Route path="/ext-exchange" component={EExchangeVoucherCon} />

      <Route path="/rpted" component={AccountingRPTCon} />
      <Route path="/safes" component={SafesCon} />
      <Route path="/stocks" component={StocksCon} />
      <Route path="/default_setting" component={DefaultSettingsCon} />
      <Route path="/int-exchange" component={IExchangeVoucherCon} />
      <Route path="/int-receipt" component={IReceiptVoucherCon} />
      <Route path="/customersCon" component={CustomersCon} />
      <Route path="/pay-trans" component={PaymentTransactionRPTCon} />
      <Route path="/AgelPeriod" component={DeptPeriodConn} />
      <Route path="/ReviewAgelPeriod" component={ReviewAgelPeriod} />
      <Route path="/ReviewLastPaid" component={RevLastPaid} />



      {/* <Route path="/permissions" component={UserPermissionsCon} /> */}
      <PrivateRoute
        path="/permissions"
        component={UserPermissionsCon}
        isAllowed={sto.User_typei == 1}
      />
      <Route path="/login" component={LoginTest} />
      <Route path="/zatca-settings" component={ZatcaSettingsCon} />


      {/* <Route path="/opening-rest" component={ORestrictionsCon} /> */}
      <Route path="/opening-rest" component={RestrictionOpenCon} />

      <Route path="/ReviewTransfer" component={ReviewTransfers} />
      <Route path="/transfer-print" component={SafeTransferPrint} />

      {/* <Route path="/rest-invoice" component={RestInvoice} /> */}
      <Route path="/rest-invoice" component={RestInvoicesCon} />

      <PrivateRoute
        path="/users-curd"
        component={UserCon}
        isAllowed={sto.User_typei == 1}
      />
      <PrivateRoute
        path="/employees"
        component={EmpoyeesCon}
        isAllowed={sto.User_typei == 1}
      />
      <PrivateRoute
        path="/user-perms"
        component={UsersPermissionsCont}
        isAllowed={sto.User_typei == 1}
      />

      <Route component={NotFound} exact path="/not-found" />
      <Route component={CostCentersCon} exact path="/costCenters" />
      <Route component={CostCenterRptCon} exact path="/costRpt" />
      <Route component={SalesPersonCon} exact path="/salesPerson" />
      <Route component={SalesmansCon} exact path="/salesPersonComm" />
      <Route component={ElectronicScaleCon} exact path="/electronic-scale" />
      <Route component={InvoiceSettings} exact path="/invoice-settings" />
      <Route component={StockMoveRPTCon} exact path="/stock-move" />
      <Route component={RevSalesmans} exact path="/ReviewSalesman" />

      <Route component={RevSalesEmp} exact path="/SalesManPrint" />
      <Route component={BanksCon} exact path="/banks" />
      <Route component={LevelsCon} exact path="/levels" />
      <Route component={PricesLevelsCon} exact path="/Priceslevels" />

      <Route component={SubscriptionRenewCon} exact path="/renew" />
      <Route
        component={InvoiceSettingsApp}
        exact
        path="/invoice-settings-app"
      />
      <Redirect to="/not-fount" />
      {/* <CashOutStoreore/> */}
    </Switch>
  );
};

export default MainRoutes;
